import { IDynamicSearchableQueryOptions } from "@timesheets/webapp-support";
import { IMethods } from "./IMethods";
import { IQueryOptions } from "./IQueryOptions";
import { RecordAny } from "@gemma/typescript-types";
import { ResolvedQueryOptions } from "@gemma/querying";
import { TypedEvent } from "@gemma/events";
import { WebApplicationConstants } from "@/setup/WebApplicationConstants";
import { clone } from "@gemma/utils";
import { getDefaultMergedDynamicQueryOptions } from "./getDefaultMergedDynamicQueryOptions";
import { isQueryOptionsChanged } from "./isQueryOptionsChanged";

export function getMethods<TFilter>(): IMethods<TFilter> {
  return {
    onQueryOptionsChange(this: IQueryOptions<TFilter>, newQueryOptions: ResolvedQueryOptions<TFilter>, _oldQueryOptions?: ResolvedQueryOptions<TFilter>, reset = true): void {
      // const isChanged = oldQueryOptions ? isQueryOptionsChanged.call(this, newQueryOptions, oldQueryOptions) : true;
      const isChanged = isQueryOptionsChanged.call(this, newQueryOptions, this.oldQueryOptions);

      if (isChanged) {
        if (newQueryOptions) {
          this.filter = newQueryOptions.filter;
          this.groupBy = newQueryOptions.groupBy;
          this.page = newQueryOptions.page;
          this.sort = newQueryOptions.sort;
        }

        if (reset && !this.isQueryOptionsLoading) {
          this.staticQueryOptionsReset();
        }

        this.oldQueryOptions = clone(newQueryOptions);
      }
    },

    onDynamicQueryOptionsChange(this: IQueryOptions<TFilter>, newQueryOptions: IDynamicSearchableQueryOptions<TFilter>, oldQueryOptions: IDynamicSearchableQueryOptions<TFilter>, reset = true) {
      const isChanged = oldQueryOptions ? isQueryOptionsChanged.call(this, newQueryOptions, oldQueryOptions) : true;

      if (isChanged) {
        const defaultMergedNewDynamicQueryOptions = getDefaultMergedDynamicQueryOptions(newQueryOptions);
        // const { merged } = mergeQueryOptions<ResolvedQueryOptions<TFilter>, ResolvedQueryOptions<TFilter>, IDynamicSearchableQueryOptions<TFilter>>(this.dynamicQueryOptions_, defaultMergedNewDynamicQueryOptions);
        this.dynamicQueryOptions_ = defaultMergedNewDynamicQueryOptions;
        if (reset && !this.isQueryOptionsLoading) {
          this.dynamicQueryOptionsReset();
        }
      }
    },

    deleteDynamicQueryOption(this: IQueryOptions<TFilter>, path: string, reset = true) {
      // const copy = clone<RecordAny>(this.dynamicQueryOptions_);
      let current: RecordAny = this.dynamicQueryOptions_;
      let current2: RecordAny = this.dynamicQueryOptions;
      const sections = path.split(".");
      while (sections.length > 1) {
        const section = sections.shift() as string;
        current = current[section];
        current2 = current2[section];
      }

      delete current[sections[0]];
      delete current2[sections[0]];
      if (reset) {
        this.dynamicQueryOptionsReset();
      }
    },

    dynamicQueryOptionsReset(this: IQueryOptions<TFilter>, newDynamicQueryOptions?: ResolvedQueryOptions<TFilter>): void {
      const event = new TypedEvent("dynamicQueryOptionsReset", {
        //
        groupedQueryOptionsId: this.groupedQueryOptionsId,
        dynamicQueryOptions: newDynamicQueryOptions || clone(this.dynamicQueryOptions_),
      });
      WebApplicationConstants.listenerEventBuses.system.emit(event);
    },

    staticQueryOptionsReset(this: IQueryOptions<TFilter>, newStaticQueryOptions: ResolvedQueryOptions<TFilter>): void {
      const queryOptions = newStaticQueryOptions || this;
      const event = new TypedEvent("staticQueryOptionsReset", {
        //
        groupedQueryOptionsId: this.groupedQueryOptionsId,
        filter: queryOptions.filter,
        groupBy: queryOptions.groupBy,
        page: queryOptions.page,
        // search: queryOptions.search,
        sort: queryOptions.sort,
      });
      WebApplicationConstants.listenerEventBuses.system.emit(event);
    },
  };
}
